import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import { Spin } from 'antd';

const Dashboard = lazy(() => import('../../container/spl/Index'));
const Dashboard1 = lazy(() => import('../../container/spl/Dashboard1'));
const StoreBucket = lazy(() => import('../../container/spl/StoreBucket'));
const EmployeeBucket = lazy(() => import('../../container/spl/EmployeeBucket'));

function SPLRoutes() {
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>  
            }
        >
            <Routes>
                <Route path="dashboard1" element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard1 />} />
                <Route path="store-bucket" element={<StoreBucket />} />
                <Route path="employees-bucket" element={<EmployeeBucket />} />
                <Route path="*" element={<Navigate to="/asm/spl/dashboard" replace />} />
            </Routes>
        </Suspense>
    );
}

export default withAdminLayout(SPLRoutes);
